import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";

export default function CheckoutSuccess() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);
  useEffect(() => {
    if (countdown === 0) { navigate("/", { replace: true }); return; }
    const timer = setTimeout(() => setCountdown(value => value - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown, navigate]);
  return <main className="checkout-page"><div className="checkout-card"><span className="login-entry-icon"><CheckCircle2 size={27} strokeWidth={1.5} /></span><h1>Purchase confirmation</h1><p>Your balance will update once payment is confirmed.</p><button type="button" className="button-primary" onClick={() => navigate("/", { replace: true })}>Return to workspace <ArrowRight size={16} /></button><small>Returning to your workspace in {countdown}s…</small></div></main>;
}
